export default __webpack_public_path__ + "static/media/reactiveswift.55b602c9.png";